import { render, staticRenderFns } from "./EditHubCategoryModal.vue?vue&type=template&id=30820ab4&"
import script from "./EditHubCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditHubCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports